import React from "react";

class ThankYou extends React.Component {
  render() {
    return (
      <div className="container mx-5 mt-5">
        <p className="title is-4">Thank you</p>
        <p className="subtitle is-4">
          Thank you for submitting your Case Review. A member of the CAETA team will begin your review and contact you with next steps.
        </p>
      </div>
    );
  }

  componentDidMount() {
    localStorage.removeItem("reviewId");
    localStorage.removeItem("searchParam1");
  }
}

export default ThankYou;
